import OrgManagementPage from "./OrgManagement";

export default OrgManagementPage;

